import { useProductsBySlug } from "@gik/api/products/productsBySlug";
import type ProductLink from "@gik/blog/models/ProductLink";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { Grid } from "@gik/ui-legacy/Grid";
import { ProductTile } from "@gik/ui-legacy/gik/ProductTile";

export interface IBuyingGuideProps {
	productLinks: ProductLink[];
}

const blockName = "buying-guide";

export function BuyingGuide({ productLinks }: IBuyingGuideProps) {
	const bem = useBemCN(blockName);

	const { data: products } = useProductsBySlug({
		ids: productLinks.map((productLink) => productLink.id),
	});

	return (
		<Grid
			{...bem()}
			cols={1}
			style={{
				gap: `4rem`,
			}}
		>
			{productLinks.map((productLink) => (
				<ProductTile
					key={productLink.slug}
					title={productLink.title}
					href={"/products/" + productLink.slug}
					imageUrl={
						products?.find((p) => p.id.toString() === productLink.id)
							?.gridImage ?? productLink.smallImageUrl
					}
					containImage={productLink.isTcProduct}
					description={productLink.shortDescription}
					direction="row"
				/>
			))}
		</Grid>
	);
}
